let loadPromise = null;

// Loads the AiDesigner bundle, which registers BOTH <mcs-ai-designer> and the
// standalone <mcs-designs-rail> custom elements. We only render the rail in the
// dashboard, but the script is the same one the /design app uses.
//
// Prod: fetch the Vite manifest at the configured CDN base and resolve the
// single entry's hashed filename. Dev: load directly from the AiDesigner vite
// dev-server URL (an ES module). The hashed URL is its own cache buster.
async function resolveDesignsRailScriptUrl(inDevEnv) {
  if (inDevEnv) {
    return process.env.VUE_APP_AIDESIGNER_URL;
  }
  const base = process.env.VUE_APP_AIDESIGNER_CDN_BASE;
  const res = await fetch(`${base}/.vite/manifest.json`);
  if (!res.ok) throw new Error(`aidesigner manifest fetch failed: ${res.status}`);
  const manifest = await res.json();
  // Lib-mode IIFE always emits a single entry — pick it by isEntry rather than
  // hardcoding the entry path (an internal Vite build detail).
  const entry = Object.values(manifest).find((e) => e && e.isEntry);
  if (!entry || !entry.file) throw new Error('aidesigner manifest has no entry');
  return `${base}/${entry.file}`;
}

export function loadDesignsRailScript({ inDevEnv } = {}) {
  if (loadPromise) return loadPromise;
  if (customElements.get('mcs-designs-rail')) {
    loadPromise = Promise.resolve();
    return loadPromise;
  }

  loadPromise = (async () => {
    const url = await resolveDesignsRailScriptUrl(inDevEnv);
    return new Promise((resolve, reject) => {
      const script = document.createElement('script');
      script.setAttribute('data-designs-rail', '');
      script.src = url;
      if (inDevEnv) {
        script.type = 'module';
        script.crossOrigin = 'anonymous';
      }
      script.onload = () => resolve();
      script.onerror = () => {
        loadPromise = null;
        reject(
          new Error(
            'Failed to load designs rail script (is `npm run dev:front` running in MyCreativeShop.AiDesigner?)'
          )
        );
      };
      document.head.appendChild(script);
    });
  })();
  // Re-arm on failure so a retry can try again.
  loadPromise.catch(() => {
    loadPromise = null;
  });
  return loadPromise;
}
